import { useHistory, useParams } from 'react-router'
import styled from 'styled-components'
import { FiPlus } from 'react-icons/fi'
import ChangeStatusModal from '../../whistleblower/new-case/modals/ChangeStatusModal'
import { useEffect, useState } from 'react'
import CloseCaseModal from './components/CloseCaseModal'
import {
    useActions,
    useTranslation,
    useTypedSelector,
    useOpenReportState,
} from '../../../../hooks'
import Spinner from '../../../layout/spinner/Spinner'
import capitilize from '../../../../helpers/string/capitilize'
import NavigationArrowLink from '../../../reusable/buttons/NavigationArrowLink'
// import ChangeResponsibleModal from './components/ChangeResponsibleModal'
import InformationBar from './components/InformationBar'
import DescriptionFilesHistoryBox from './components/description-files-history-box/DescriptionFilesHistoryBox'
import MessagesInternalNotesBox from './components/messages-notes-box/MessagesInternalNotesBox'
import { truncate } from '../../../../helpers/string'
import ReporterInformationModal from './components/ReporterInformationModal/ReporterInformationModal'
import ChangeCategoryModal from './components/ChangeCategoryModal'
import { UpdatedStatus } from '../../../../state/actions'
import { useLocation } from 'react-router-dom'
import { CloseReportPayload } from '../../../../state/action-creators'
import ClosedOrForwardedBox from './components/ClosedOrForwadredBox'
import ReporterInfoAnonymModal from './components/ReporterInformationModal/ReporterInfoAnonymModal'
import CaseClosedModal from './components/ReporterInformationModal/CaseClosedModal'
import {
    Category,
    singleCategoryTransformer,
} from '../../../../state/transformers/CategoryTransformer'
import TranscriptionModal from './components/TranscriptionModal'

// import Report from '../../whistleblower/access-report/frames/Report'

const Container = styled.div`
    width: 100%;
    padding: 4rem;
`

const HeadingContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`

const FlexContainer = styled.div`
    display: flex;
    gap: 2.2rem;
    padding-top: 2rem;
    @media screen and (max-width: 1000px) {
        flex-direction: column;
    }
`

const LeftContainer = styled.div`
    width: 60%;
    min-height: 55rem;
    height: 55vh;
    @media screen and (max-width: 1000px) {
        width: 100%;
    }
`

const RightContainer = styled.div`
    width: 40%;
    min-height: 55rem;
    height: 55vh;
    @media screen and (max-width: 1000px) {
        width: 100%;
    }
`

const SpinnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    padding-top: 38vh;
`

const MidSection = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    @media screen and (max-width: 480px) {
        flex-direction: column;
    }
`

const FlexCategoryStatus = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 480px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 2rem;
    }
`

const LightText = styled.p`
    font-size: 1.2rem;
    color: ${({ theme }) => theme.greyText};
    margin-bottom: 1rem;
`

const Title = styled.h3`
    font-size: 2.4rem;
    color: ${({ theme }) => theme.primary};
    font-weight: 600;
    margin-bottom: 2rem;
`

const GreyButton = styled.div`
    height: 3.2rem;

    border: ${({ theme }) => `1px solid ${theme.greyText}`};
    display: flex;
    align-items: center;
    border-radius: 10rem;
    cursor: pointer;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.greyText};
    transition: all 0.3s;
`
interface isactiveProp {
    isactive: boolean
    isDisabled?: boolean
}
interface CategoryButtonProps extends isactiveProp {
    isForwardedOrClosed?: boolean
}

const CategoryButton = styled(GreyButton)<CategoryButtonProps>`
    display: flex;
    justify-content: center;
    margin-right: 12rem;
    color: ${({ theme, isactive }) =>
        isactive ? theme.primary : theme.greyText};
    border: ${({ theme, isactive }) =>
        isactive
            ? `1px solid ${theme.primary}`
            : `1px solid ${theme.greyText}`};
    min-width: 10.9rem;
    max-width: 18rem;
    padding: 0 1rem;

    cursor: ${({ isForwardedOrClosed = false }) =>
        isForwardedOrClosed && 'default'};

    &:hover {
        color: ${({ theme, isForwardedOrClosed }) =>
            !isForwardedOrClosed && theme.white};
        background: ${({ theme, isForwardedOrClosed }) =>
            !isForwardedOrClosed && theme.primary};
    }
`

const UncategorizedIconText = styled.div`
    display: flex;
    gap: 0.3rem;
`

const CategoryButtonContact = styled(CategoryButton)`
    cursor: default;

    &:hover {
        color: ${({ theme }) => theme.primary};
        background: transparent;
    }
`

const ActionRequiredButton = styled(GreyButton)<isactiveProp>`
    width: fit-content;
    padding-right: 1rem;
    background: ${({ theme, isactive }) => isactive && `${theme.yellow}50`};
    border: ${({ theme, isactive }) =>
        isactive ? 'none' : `1px solid ${theme.greyText}`};
    color: ${({ theme, isactive }) =>
        isactive ? theme.yellow : theme.greyText};
    cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};

    &:hover {
        opacity: 0.6;
    }
`

const AwaitingResponseButton = styled(GreyButton)<isactiveProp>`
    margin-left: 1rem;
    width: fit-content;
    padding-right: 1rem;
    background: ${({ theme, isactive }) => isactive && `${theme.blue}50`};
    border: ${({ theme, isactive }) =>
        isactive ? 'none' : `1px solid ${theme.greyText}`};
    color: ${({ theme, isactive }) => (isactive ? theme.blue : theme.greyText)};
    cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};

    &:hover {
        opacity: 0.6;
    }
`

export const PlusIcon = styled(FiPlus)`
    font-size: 1.4rem;
`

const Circle = styled.div<isactiveProp>`
    height: 1.2rem;
    width: 1.2rem;
    border-radius: 50%;
    margin: 0 0.8rem;
`

const ActionRequiredCircle = styled(Circle)`
    background: ${({ theme, isactive }) =>
        isactive ? theme.yellow : theme.greyText};
`

const AwaitingResponseCircle = styled(Circle)`
    background: ${({ theme, isactive }) =>
        isactive ? theme.blue : theme.greyText};
`

const Flex = styled.div`
    display: flex;
    align-items: center;
`

const SingleCase: React.FC = () => {
    const [isTranscriptionModalOpen, setIsTranscriptModalOpen] = useState(false)
    const [isGDPRModalOpen, setIsGDPRModalOpen] = useState(false)

    const { user } = useTypedSelector((state) => state.auth)

    const reportState = useOpenReportState()
    const openReport =
        reportState.type === 'loaded' ? reportState.openReport : null
    const openReportMessages =
        reportState.type === 'loaded' ? reportState.openReportMessages : []

    const { categories } = useTypedSelector((state) => state.category)

    const {
        getSingleReport,
        // updateReport,
        caseworkerShowLatestMessage,
        caseworkerLeaveReport,
        clearInternalNotes,
        updateStatus,
        closeReport,
        showSpecialForwardedMessage,
    } = useActions()

    const history = useHistory()

    const location = useLocation()

    const translation = useTranslation()
    const { id } = useParams<{ id: string }>()
    const [activeStatusModal, setActiveStatusModal] = useState<null | string>(
        null
    )
    const [activeStatus, setActiveStatus] = useState<string>(
        openReport?.status ?? ''
    )

    const [isCloseCaseModalOpen, setIsCloseCaseModalOpen] = useState(false)
    const [, setIsChangeResponsibleModalOpen] = useState(false)

    const [isReporterInformationModalOpen, setIsReporterInformationModalOpen] =
        useState(false)

    const [isChangeCategoryModalOpen, setIsChangeCategoryModalOpen] =
        useState(false)

    useEffect(() => {
        if (!user || !id) {
            return
        }

        getSingleReport(parseInt(id), translation)

        // eslint-disable-next-line
    }, [user, id])

    useEffect(() => {
        return () => {
            caseworkerLeaveReport()
            clearInternalNotes()
        }
        // eslint-disable-next-line
    }, [location])

    useEffect(() => {
        if (activeStatus === 'New') {
            handleUpdateReportStatus('action required')
        }
        // eslint-disable-next-line
    }, [activeStatus])

    useEffect(() => {
        setActiveStatus(openReport?.status ?? '')
    }, [openReport])

    useEffect(() => {
        if (openReport && openReport.talk) {
            window.Echo.channel(`case-talk-${openReport.talk.data.id}`).listen(
                '.message',
                (message: any) => caseworkerShowLatestMessage(message)
            )
        }

        return () => {
            if (openReport && openReport.talk) {
                window.Echo.leave(`case-talk-${openReport.talk.data.id}`)
            }
        }
        // eslint-disable-next-line
    }, [openReportMessages])

    const [specialMessageCreated, setSpecialMessageCreated] = useState(false)

    useEffect(() => {
        if (specialMessageCreated) {
            return
        }

        if (openReport?.forwarded_at) {
            const specialMessage = {
                created_at: openReport.forwarded_at,
                to: 'Nikulás Óskarsson',
                type: 'forwarded',
            }
            showSpecialForwardedMessage(specialMessage)
            setSpecialMessageCreated(true)
        }

        // eslint-disable-next-line
    }, [openReport, openReportMessages])

    const handleUpdateReportStatus = async (status: UpdatedStatus) => {
        if (!user || !openReport) {
            return
        }

        const payload = {
            status,
        }

        const success = await updateStatus(openReport.id, payload)

        return success
    }

    const handleCloseCase = async (status: string, comment: string) => {
        if (!openReport) return

        const payload: CloseReportPayload = {
            status: status,
            closed_comment: comment,
        }

        await closeReport(openReport.id, payload)

        setIsCloseCaseModalOpen(false)
        setIsGDPRModalOpen(true)
    }

    const handleOpenChangeCategoryModal = () => {
        if (openReport?.closed_at) {
            return
        }

        setIsChangeCategoryModalOpen(true)
    }

    const [translateSelectedCategory, setTranslateSelectedCategory] =
        useState<Category | null>(null)

    useEffect(() => {
        if (openReport?.category) {
            const findCategorySlug = categories?.find(
                (category: { name: string }) =>
                    category.name === openReport?.category
            )

            if (findCategorySlug) {
                const transformedSingleCategory = singleCategoryTransformer(
                    findCategorySlug,
                    translation
                )
                setTranslateSelectedCategory(transformedSingleCategory)
            }
        }
    }, [openReport, categories, translation])

    return (
        <>
            {reportState.type === 'loaded' ? (
                <Container>
                    <div
                        style={{
                            paddingBottom: '2rem',
                        }}
                    >
                        <div
                            style={{
                                width: '8rem',
                            }}
                        >
                            <NavigationArrowLink
                                onClickCallback={() => history.goBack()}
                                linkText={
                                    translation.caseworkerOpenReport.goBack
                                }
                            />
                        </div>

                        {openReport?.closed_at && <ClosedOrForwardedBox />}

                        <InformationBar
                            report={openReport}
                            messages={openReportMessages}
                            openReporterModal={() =>
                                setIsReporterInformationModalOpen(true)
                            }
                            openChangeResponsibleModal={() =>
                                setIsChangeResponsibleModalOpen(true)
                            }
                            openCloseCaseModal={() =>
                                setIsCloseCaseModalOpen(true)
                            }
                        />
                    </div>

                    {isReporterInformationModalOpen && openReport && (
                        <>
                            {openReport.case_type === 'anonymous' ? (
                                <ReporterInfoAnonymModal
                                    closeModal={() =>
                                        setIsReporterInformationModalOpen(false)
                                    }
                                />
                            ) : (
                                <ReporterInformationModal
                                    closeModal={() =>
                                        setIsReporterInformationModalOpen(false)
                                    }
                                    reporter={openReport.reporter?.data!}
                                />
                            )}
                        </>
                    )}

                    {/* {isReporterInformationModalOpen && (
                        <ReporterInformationModal
                            closeModal={() =>
                                setIsReporterInformationModalOpen(false)
                            }
                            reporter={openReport.reporter.data}
                        />
                    )} */}

                    {isGDPRModalOpen && (
                        <CaseClosedModal
                            closeModal={() => setIsGDPRModalOpen(false)}
                        />
                    )}

                    {activeStatusModal && (
                        <ChangeStatusModal
                            statusChange={
                                activeStatusModal === 'Action Required'
                                    ? translation.caseworkerOpenReport
                                          .actionRequired
                                    : translation.caseworkerOpenReport
                                          .awaitingResponse
                            }
                            statusChangePayload={
                                activeStatusModal === 'Action Required'
                                    ? 'action required'
                                    : 'awaiting response'
                            }
                            modalAction={(status: UpdatedStatus) =>
                                handleUpdateReportStatus(status)
                            }
                            closeModal={() => setActiveStatusModal(null)}
                        />
                    )}
                    {isCloseCaseModalOpen && (
                        <CloseCaseModal
                            handleCloseCase={handleCloseCase}
                            closeModal={() => setIsCloseCaseModalOpen(false)}
                        />
                    )}
                    {isTranscriptionModalOpen && (
                        <TranscriptionModal
                            close={() => setIsTranscriptModalOpen(false)}
                        />
                    )}
                    {isChangeCategoryModalOpen && (
                        <ChangeCategoryModal
                            closeModal={() =>
                                setIsChangeCategoryModalOpen(false)
                            }
                            selectedCategory={{
                                id: openReport?.category_id ?? null,
                                name: openReport?.category ?? null,
                                slug: '',
                            }}
                        />
                    )}

                    <HeadingContainer>
                        <MidSection>
                            <div>
                                <LightText>
                                    {translation.caseworkerOpenReport.title}
                                </LightText>
                                <Title>{openReport?.title}</Title>
                            </div>
                            <FlexCategoryStatus>
                                <div>
                                    <LightText>
                                        {translation.reusable.category}
                                    </LightText>
                                    {user ? (
                                        <CategoryButton
                                            onClick={
                                                handleOpenChangeCategoryModal
                                            }
                                            isactive={
                                                openReport?.category !== null
                                            }
                                            isForwardedOrClosed={
                                                !!(
                                                    openReport?.forwarded_at ||
                                                    openReport?.closed_at
                                                )
                                            }
                                        >
                                            {translateSelectedCategory ? (
                                                truncate(
                                                    capitilize(
                                                        translateSelectedCategory.name
                                                    ),
                                                    25
                                                )
                                            ) : (
                                                <UncategorizedIconText>
                                                    <PlusIcon />
                                                    {
                                                        translation
                                                            .forwardReportPage
                                                            .uncategorized
                                                    }
                                                </UncategorizedIconText>
                                            )}
                                        </CategoryButton>
                                    ) : (
                                        <CategoryButtonContact isactive={true}>
                                            {openReport?.category &&
                                                truncate(
                                                    capitilize(
                                                        openReport?.category
                                                    ),
                                                    25
                                                )}
                                        </CategoryButtonContact>
                                    )}
                                </div>
                                <div>
                                    <LightText>
                                        {
                                            translation.caseworkerOpenReport
                                                .status
                                        }
                                    </LightText>
                                    <Flex>
                                        <ActionRequiredButton
                                            isDisabled={
                                                openReport?.closed_at !== null
                                            }
                                            onClick={() => {
                                                if (!openReport?.closed_at) {
                                                    setActiveStatusModal(
                                                        'Action Required'
                                                    )
                                                }
                                            }}
                                            isactive={
                                                openReport?.status ===
                                                'Action Required'
                                            }
                                        >
                                            <ActionRequiredCircle
                                                isactive={
                                                    openReport?.status ===
                                                    'Action Required'
                                                }
                                            />
                                            {
                                                translation.caseworkerOpenReport
                                                    .actionRequired
                                            }
                                        </ActionRequiredButton>
                                        <AwaitingResponseButton
                                            isDisabled={
                                                openReport?.closed_at !== null
                                            }
                                            onClick={() => {
                                                if (!openReport?.closed_at) {
                                                    setActiveStatusModal(
                                                        'Awaiting Response'
                                                    )
                                                }
                                            }}
                                            isactive={
                                                openReport?.status ===
                                                'Awaiting Response'
                                            }
                                        >
                                            <AwaitingResponseCircle
                                                isactive={
                                                    openReport?.status ===
                                                    'Awaiting Response'
                                                }
                                            />
                                            {
                                                translation.caseworkerOpenReport
                                                    .awaitingResponse
                                            }
                                        </AwaitingResponseButton>
                                    </Flex>
                                </div>
                            </FlexCategoryStatus>
                        </MidSection>
                    </HeadingContainer>

                    <FlexContainer>
                        <LeftContainer>
                            <DescriptionFilesHistoryBox
                                description={openReport?.description ?? ''}
                                files={openReport?.files?.data ?? []}
                                openTranscriptionModal={() =>
                                    setIsTranscriptModalOpen(true)
                                }
                            />
                        </LeftContainer>
                        <RightContainer>
                            <MessagesInternalNotesBox />
                        </RightContainer>
                    </FlexContainer>
                </Container>
            ) : (
                <SpinnerContainer>
                    <Spinner />
                </SpinnerContainer>
            )}
        </>
    )
}

export default SingleCase
